// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
}); // This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
}); // This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.

document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.

document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
}); // This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.

document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
}); // This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.

document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
}); // This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.

document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

class ProductSubscription extends HTMLElement {
  constructor() {
    super();

    this.submitRadioWrap = document.querySelector('.product-form__item--submit-radio__wrapper');
    this.subSubmit = document.querySelector('.product-form-controls-subscription-submit');

    if(this.submitRadioWrap && this.subSubmit){
      this.submitRadioWrap.addEventListener('click', ()=> {
        this.querySelector('label[for="subscribeRadio"]').click();
        this.submitRadioWrap.style.display = 'none';
        this.querySelector('.subscription-content').style.display = 'block';
        this.subSubmit.classList.remove('product-form-controls-subscription-submit');
      })
    }

    document.removeEventListener("click", window.quickHandler);

    window.quickHandler = function (event) {
      const quickSubRadio = event.target.closest(".quick-product .product-form__item--submit-radio__wrapper");
      const quickPopup = document.querySelector('.quick-product');

      if (quickSubRadio && quickPopup) {
        quickPopup.querySelector('label[for="quick-subscribeRadio"]').click();
        quickSubRadio.style.display = 'none';
        quickPopup.querySelector('.subscription-content').style.display = 'block';
        quickPopup.querySelector('.product-form-controls-subscription-submit')
          .classList.remove('product-form-controls-subscription-submit');
      }
    };

    document.addEventListener("click", window.quickHandler);

    this.addEventListener('change', this.onOptionChange.bind(this));
  }

  onOptionChange(){
    const selectedVinput = this.querySelector('input[name="subscription"]');
    const productForm = this.closest('[data-section-type="product"]').querySelector('.product-form');
    const sellingPlanInput = productForm.querySelector('input[name="selling_plan"]');
    const selectedSellingPlan = this.querySelector('input.subs-selling-plan-input:checked');

    if(selectedVinput.checked){
      if(sellingPlanInput){
        sellingPlanInput.value = selectedSellingPlan.value;
      }else{
        productForm.insertAdjacentHTML("beforeend", `<input type="hidden" name="selling_plan" value="${selectedSellingPlan.value}">`);
      }
    }else{
      if(sellingPlanInput){
        sellingPlanInput.value = '';
      }
      this.querySelector('.subscription-content').style.display = 'none';
      this.submitRadioWrap.style.display = 'block';
      this.subSubmit.classList.add('product-form-controls-subscription-submit');
    }
  }
}

customElements.define('product-subscription', ProductSubscription);